import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var EmailSVG = function EmailSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__secondary-color-fill",
    x: "7",
    y: "2.937",
    width: "24",
    height: "33",
    rx: "1.942"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__no-fill",
    points: "13.924 29.401 4.429 38.168 4.429 20.634 13.924 29.401"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__no-fill",
    points: "33.571 20.634 33.571 38.168 24.076 29.401 33.571 20.634"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M33.013,17.853l-10.722,9.9-2.465-2.271a1.2,1.2,0,0,0-1.652,0L15.709,27.75l-10.722-9.9a1.258,1.258,0,0,1,.328-.3l.036-.024L5.4,17.5,18.126,9.523a2.511,2.511,0,0,1,1.748,0L32.6,17.5l.049.025.036.024A1.258,1.258,0,0,1,33.013,17.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M35.9,18.327a4.914,4.914,0,0,0-.7-1.591,4.02,4.02,0,0,0-1.312-1.287L21.113,7.435a4.732,4.732,0,0,0-4.226,0L4.113,15.449A4.02,4.02,0,0,0,2.8,16.736a4.914,4.914,0,0,0-.7,1.591,3.268,3.268,0,0,0-.1.753V38.508a2.375,2.375,0,0,0,.486,1.445,2.437,2.437,0,0,0,1.943.984H33.571a2.437,2.437,0,0,0,1.943-.984A2.375,2.375,0,0,0,36,38.508V19.08A3.268,3.268,0,0,0,35.9,18.327ZM5.315,17.55l.036-.024L5.4,17.5,18.126,9.523a2.511,2.511,0,0,1,1.748,0L32.6,17.5l.049.025.036.024a1.258,1.258,0,0,1,.328.3l-10.722,9.9-2.465-2.271a1.2,1.2,0,0,0-1.652,0L15.709,27.75l-10.722-9.9A1.258,1.258,0,0,1,5.315,17.55Zm-.886,3.084L13.924,29.4,4.429,38.168ZM7.634,38.508l8.075-7.455,1.8-1.652L19,28.017,20.494,29.4l1.8,1.652,8.075,7.455ZM24.076,29.4l9.495-8.767V38.168Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__no-fill",
    points: "30.366 38.508 7.634 38.508 15.709 31.053 17.506 29.401 19 28.017 20.494 29.401 22.291 31.053 30.366 38.508"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M36.014,11.229v.03a7.06,7.06,0,0,1-4.989,4.959h-.031a.386.386,0,0,0,0,.751h.031a7.059,7.059,0,0,1,4.989,4.958v.031a.34.34,0,0,0,.669,0v-.031a7.059,7.059,0,0,1,4.989-4.958H41.7a.386.386,0,0,0,0-.751h-.031a7.06,7.06,0,0,1-4.989-4.959v-.03a.34.34,0,0,0-.669,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M29.125,5.5v.018a4.149,4.149,0,0,1-2.932,2.914h-.018a.227.227,0,0,0,0,.442h.018a4.149,4.149,0,0,1,2.932,2.914v.018a.2.2,0,0,0,.393,0v-.018a4.152,4.152,0,0,1,2.933-2.914h.018a.227.227,0,0,0,0-.442h-.018a4.152,4.152,0,0,1-2.933-2.914V5.5a.2.2,0,0,0-.231-.162A.2.2,0,0,0,29.125,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M25.975,18.212v.01A2.39,2.39,0,0,1,24.287,19.9h-.011a.13.13,0,0,0,0,.254h.011a2.39,2.39,0,0,1,1.688,1.678v.01a.115.115,0,0,0,.226,0v-.01a2.388,2.388,0,0,1,1.688-1.678h.01a.13.13,0,0,0,0-.254h-.01A2.388,2.388,0,0,1,26.2,18.222v-.01a.115.115,0,0,0-.133-.093A.113.113,0,0,0,25.975,18.212Z"
  }));
};
EmailSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
EmailSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Email")
};
export default withDetailedIcon(EmailSVG);